{
  "header": {
    "nameVariable": {
      "id": "46b533e2-cd73-4fe5-8560-eb1399df775d",
      "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
      "nodeId": "ns=1;i=6193",
      "displayName": "Name",
      "variablePath": "Identification.Name",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "0ac27664-2069-45c0-9ed0-61978f0042c2",
      "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
      "nodeId": "ns=1;i=6237",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Controller",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "c439ac8b-b017-4875-8c34-cb23af699ec8",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6142",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "de5bcbf6-b389-40ed-a706-29a9d6410d7b",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6198",
                "displayName": "ManufacturerUri",
                "variablePath": "Identification.ManufacturerUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "c7d48509-34e1-4a57-825e-bdb97ecfd76e",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6199",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "38fc42cb-d5f7-4697-ac28-3a0e8e51448e",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6143",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "c7083a11-f6f4-4e05-8782-fcc04069a367",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6201",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Construction Year",
              "showAsLink": false,
              "valueVariable": {
                "id": "c51a0cd4-c030-4a98-845b-fecd561054d6",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6204",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "65f4438f-d2ab-465d-8441-6f747df85fe8",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6203",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "fcc563c1-4ec9-4b54-ac99-8b0003fc2597",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6205",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Hardware Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "b4371204-69c2-47b6-ac7b-ce2b5dfb7905",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6204",
                "displayName": "HardwareRevision",
                "variablePath": "Identification.HardwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            }
          ],
          "title": "Identification",
          "placeholderObject": "AssetManagement.Assets.Controllers.<Controller>.[PLACEHOLDER]"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Tool",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "2a2edbf1-e94f-41c5-a103-4c6abbe093ea",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6142",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer Uri",
              "showAsLink": false,
              "valueVariable": {
                "id": "de5bcbf6-b389-40ed-a706-29a9d6410d7b",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6198",
                "displayName": "ManufacturerUri",
                "variablePath": "Identification.ManufacturerUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "7224dcbe-5679-4eea-9361-e2a5a8e7d0a3",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6199",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "6211343b-a775-469c-bde1-9781e76b0060",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6143",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "b47d9d4e-c024-4674-a8a2-b427fff53662",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6201",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Construction Year",
              "showAsLink": false,
              "valueVariable": {
                "id": "5f87bde9-28ac-41a0-9a2c-6118dd7a72d1",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6204",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "79f038c6-5ed8-46dd-933b-e746435cb1e7",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6203",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "showAsLink": false,
              "valueVariable": {
                "id": "d94d7978-2e5d-48f9-86fa-c3780f89198f",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6204",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Hardware Revision",
              "showAsLink": false,
              "valueVariable": {
                "id": "bc623e14-ff1f-4af1-baf8-8e35d553cc73",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6205",
                "displayName": "HardwareRevision",
                "variablePath": "Identification.HardwareRevision",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Operation Cycle Counter",
              "showAsLink": false,
              "valueVariable": {
                "id": "5d0614b5-5018-4ba6-81b4-80f72a4d3cd5",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6206",
                "displayName": "OperationCycleCounter",
                "variablePath": "OperationCounters.OperationCycleCounter",
                "dataType": "UInt64",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "title": "Identification",
          "placeholderObject": "AssetManagement.Assets.Tools.<Tool>.[PLACEHOLDER]"
        },
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Last Service",
              "showAsLink": false,
              "valueVariable": {
                "id": "22079d56-0d42-4b2b-beeb-403390af1380",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6111",
                "displayName": "LastService",
                "variablePath": "Maintenance.<GroupIdentifier>.Service.LastService",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Service Place",
              "showAsLink": false,
              "valueVariable": {
                "id": "858f148f-822d-4fbc-9a18-169e9ce62df6",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=1;i=6112",
                "displayName": "ServicePlace",
                "variablePath": "Maintenance.<GroupIdentifier>.Service.ServicePlace",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ],
          "title": "Maintenance.Service",
          "placeholderObject": "AssetManagement.Assets.Tools.<Tool>.[PLACEHOLDER]"
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Results",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Result Id",
              "showAsLink": false,
              "valueVariable": {
                "id": "09ed9c81-f573-4fb5-b9e1-208f165a17ef",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=14",
                "displayName": "ResultId",
                "variablePath": "ResultMetaData.ResultId",
                "dataType": "TrimmedString",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Result Evaluation",
              "showAsLink": false,
              "valueVariable": {
                "id": "15fe71fd-684e-44ad-9996-62bf25d88bf5",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=1;i=3008",
                "displayName": "ResultEvaluation",
                "variablePath": "ResultMetaData.ResultEvaluation",
                "dataType": "Enum",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "enumValues": {
                  "0": "Undefined",
                  "1": "OK",
                  "2": "NotOk",
                  "3": "NotDecidable"
                }
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Result Evaluation Code",
              "showAsLink": false,
              "valueVariable": {
                "id": "1ddc4753-16c7-491e-b848-0fd022e5e2ad",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=1;i=3007",
                "displayName": "ResultEvaluationCode",
                "variablePath": "ResultMetaData.ResultEvaluationCode",
                "dataType": "Int64",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Result Evaluation Details",
              "showAsLink": false,
              "valueVariable": {
                "id": "ad026522-91d9-44a0-865c-0a8eb135d069",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=21",
                "displayName": "ResultEvaluationDetails",
                "variablePath": "ResultMetaData.ResultEvaluationDetails",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Sequence Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "5cb2e213-96af-4085-8f45-16f1e72b784a",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=0;i=6",
                "displayName": "SequenceNumber",
                "variablePath": "ResultMetaData.SequenceNumber",
                "dataType": "UInt64",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Creation Time",
              "showAsLink": false,
              "valueVariable": {
                "id": "73b68c9d-5cac-4fb5-8616-2c5c54b61d77",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=294",
                "displayName": "CreationTime",
                "variablePath": "ResultMetaData.CreationTime",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Classification",
              "showAsLink": false,
              "valueVariable": {
                "id": "2f0bb7bb-3e90-45b9-b1eb-2019885abcf3",
                "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
                "nodeId": "ns=0;i=3",
                "displayName": "Classification",
                "variablePath": "ResultMetaData.Classification",
                "dataType": "Byte",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Start Time",
              "showAsLink": false,
              "valueVariable": {
                "id": "2a759280-3d24-4965-b6f5-1eb34b4b8e3c",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=294",
                "displayName": "StartTime",
                "variablePath": "ResultMetaData.ProcessingTimes.StartTime",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "End Time",
              "showAsLink": false,
              "valueVariable": {
                "id": "8b530927-398e-418e-93b0-7ec0b2fd7e9b",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=294",
                "displayName": "EndTime",
                "variablePath": "ResultMetaData.ProcessingTimes.EndTime",
                "dataType": "UtcTime",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Is Partial",
              "showAsLink": false,
              "valueVariable": {
                "id": "dc4775ef-d9bf-4b64-946a-8f6e59f09737",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=1",
                "displayName": "IsPartial",
                "variablePath": "ResultMetaData.IsPartial",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Is Simulated",
              "showAsLink": false,
              "valueVariable": {
                "id": "d487b4eb-542b-46d7-a611-b38fda8dac0e",
                "modelUri": "http://opcfoundation.org/UA/Machinery_Result/",
                "nodeId": "ns=0;i=1",
                "displayName": "IsSimulated",
                "variablePath": "ResultMetaData.IsSimulated",
                "dataType": "Boolean",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ],
          "placeholderObject": "ResultManagement.Results.<ResultVariable>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "09ed9c81-f573-4fb5-b9e1-208f165a17ef",
            "modelUri": "http://opcfoundation.org/UA/IJT/Base/",
            "nodeId": "ns=1;i=3004",
            "displayName": "Name",
            "variablePath": "ResultMetaData.Name",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Mandatory",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
